import React from 'react';
import {BaseToolbarJson, BaseToolbarSelect,} from 'wsc-react-custom-form';

export const Settings = () => {
    return (
        <>
            <BaseToolbarJson propKey="names" label="希望提交的表单值" widthRation={80}/>
            <BaseToolbarSelect
                propKey='hidden'
                label='隐藏'
                tooltipTitle='隐藏'
                options={[
                    { value: 'true', label: '是' },
                    { value: 'false', label: '否' },
                ]}
                widthRation={50}
            />
        </>
    );
};
